export const GRAYLOG_LOG_SENDING_TIMER_IN_SECONDS = 60;
export const GRAYLOG_AVOID_PREFIXING_OBJECT_KEYS = {
  host: true,
};
